import { Component, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

const noop = () => { };

@Component({
	selector: 'password-input',
	template: `<div class="input-group mb-2 mr-sm-2 mb-sm-0">
							<ng-content></ng-content>
							<div matTooltip="Visualizza/Nascondi Password" matTooltipPosition="after" class="input-group-addon" #toggler>
								<span class="glyphicon glyphicon-eye-open"></span>
							</div>
						</div>`,
	providers: [
		{ provide: NG_VALUE_ACCESSOR, multi: true, useExisting: ShowHidePassword }
	]
})
export class ShowHidePassword implements AfterViewInit, ControlValueAccessor {

	private _value: string;
	private _onChange: (_: any) => void = noop;

	@ViewChild('toggler') toggler: ElementRef;

	constructor(private elt: ElementRef) { }

	get value(): any { return this._value; };

	set value(v: any) {
		if (v !== this._value) {
			this._value = v;
			this._onChange(v);
		}
	}

	ngAfterViewInit() {
		let __this = this;
		let textbox = this.elt.nativeElement.children[0].children[0];
		let toggler = __this.toggler.nativeElement;
		let togglerIcon = toggler.childNodes[1];
		toggler.addEventListener('click', (e) => {
			if (textbox.type === 'password') {
				togglerIcon.classList.remove('glyphicon-eye-open');
				togglerIcon.classList.add('glyphicon-eye-close');
			} else {
				togglerIcon.classList.remove('glyphicon-eye-close');
				togglerIcon.classList.add('glyphicon-eye-open');
			}
			textbox.type = textbox.type === 'password' ? 'text' : 'password';
		});

	}

	writeValue(value: any) {
		this._value = value;
	}

	registerOnChange(fn: (value: any) => void) {
		this._onChange = fn;
	}

	registerOnTouched(fn: any) { }
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/show-hide-password/show-hide-password.component.ts